
class InvoiceApi {

       
    // updateState(data, accountId) {
    //     var url = apiUrl + 'invoices/state/';
    //     return api.call('put', url + data.id, data)
    //         .then(({ data }) => {
    //             return data
    //         });
    // }

    updateState(data, accountId) {
        const url = apiUrl + `invoices/state/${data.id}?accountId=${accountId || ''}`;
        return api.call('put', url, data)
          .then(({ data }) => data);
      }

    getNextNumber() {
        var url = apiUrl + 'invoices/next-number';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getInvoiceStatus() {
        var url = apiUrl + 'invoices/states';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getListByCurrentBusiness(params = {})
    {
        console.log('InvoiceApi.getListByCurrentBusiness', params);
        var url = apiUrl + 'invoices/currentBusiness/';

        // Build query string from params
        const queryParams = new URLSearchParams();

        if (params.page) queryParams.append('page', params.page);
        if (params.pageSize) queryParams.append('pageSize', params.pageSize);
        if (params.invoiceNumber) queryParams.append('invoiceNumber', params.invoiceNumber);
        if (params.customerId) queryParams.append('customerId', params.customerId);
        if (params.status) queryParams.append('status', params.status);
        if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
        if (params.dateTo) queryParams.append('dateTo', params.dateTo);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortDirection) queryParams.append('sortDirection', params.sortDirection);

        const queryString = queryParams.toString();
        if (queryString) {
            url += '?' + queryString;
        }

        console.log('Invoice API URL:', url);

        return api.call('get', url)
            .then(({ data }) => {
                return data
            });

    }

    getListByCurrentTenant(){
        var url = apiUrl + 'invoices/currentUser/';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getList() {
        var url = apiUrl + 'invoices';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }


    get(id) {
        var url = apiUrl + 'invoices/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });
    }
    create(data) {
        var url = apiUrl + 'invoices';
        return api.call('post', url, data)
            .then(({ data }) => {
                return data
            });

    }
    update(data) {
        var url = apiUrl + 'invoices/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }
    delete(id) {
        var url = apiUrl + 'invoices/';
        return api.call('delete', url + id)
            .then(({ data }) => {
                return data
            });
    }

}

export default InvoiceApi;